(()=>{
 const init=(root)=>{
  if(!root||root.dataset.sppReviewsInit==='1')return;root.dataset.sppReviewsInit='1';
  const track=root.querySelector('[data-review-track]'),dots=root.querySelector('[data-review-dots]');
  const prev=root.querySelector('[data-review-prev]'),next=root.querySelector('[data-review-next]');
  if(!track||!dots)return;
  const cards=Array.from(track.children);let dotButtons=[];
  const expand=root.querySelector('[data-spp-review-expand]');
  expand?.addEventListener('click',()=>{
    const expanded=track.classList.toggle('is-expanded');
    expand.setAttribute('aria-expanded',String(expanded));
    expand.innerHTML=expanded?'Back to Carousel <span aria-hidden="true">←</span>':'Read All Product Reviews <span aria-hidden="true">→</span>';
    if(!expanded)track.scrollLeft=0;
    update();
  });
  const reduced=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
  const locations=()=>cards.map(c=>c.offsetLeft-cards[0].offsetLeft);
  const limit=()=>Math.max(0,track.scrollWidth-track.clientWidth);
  const move=(direction)=>{
   const stop=locations(),left=track.scrollLeft;
   const target=direction>0?stop.find(x=>x>left+5):stop.slice().reverse().find(x=>x<left-5);
   track.scrollTo({left:Math.max(0,Math.min(limit(),target??(direction>0?limit():0))),behavior:reduced()?'auto':'smooth'});
  };
  prev?.addEventListener('click',()=>move(-1));next?.addEventListener('click',()=>move(1));
  const update=()=>{
   if(track.classList.contains('is-expanded')){
    if(prev)prev.hidden=true;if(next)next.hidden=true;
    dots.hidden=true;return;
   }
   const max=limit(),overflow=max>4;
   if(prev){prev.hidden=!overflow;prev.disabled=track.scrollLeft<5;}
   if(next){next.hidden=!overflow;next.disabled=track.scrollLeft>max-5;}
   if(!overflow){dots.replaceChildren();dotButtons=[];dots.hidden=true;return;}
   dots.hidden=false;
   const stops=locations().filter(x=>x<=max+5);
   if(stops.length!==dotButtons.length){
    dots.replaceChildren();
    dotButtons=stops.map((v,i)=>{
     const button=document.createElement('button');button.type='button';button.className='spp-gr__dot';
     button.setAttribute('aria-label','Show review '+(i+1));
     button.addEventListener('click',()=>track.scrollTo({left:v,behavior:reduced()?'auto':'smooth'}));
     dots.appendChild(button);return button;
    });
   }
   const active=stops.reduce((best,v,i)=>Math.abs(v-track.scrollLeft)<Math.abs(stops[best]-track.scrollLeft)?i:best,0);
   dotButtons.forEach((button,i)=>{button.classList.toggle('is-active',i===active);button.setAttribute('aria-current',i===active?'true':'false');});
  };
  track.addEventListener('scroll',update,{passive:true});
  if('ResizeObserver'in window)new ResizeObserver(update).observe(track);
  else window.addEventListener('resize',update);
  update();
 };
 const boot=scope=>{if(scope.matches?.('[data-spp-reviews]'))init(scope);scope.querySelectorAll?.('[data-spp-reviews]').forEach(init);};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(document));
 else boot(document);
 document.addEventListener('shopify:section:load',e=>boot(e.target));
})();